import { createApiRef } from '@backstage/core-plugin-api';

export interface PageView {
  page: string;
  user: string;
  userEntityRef: string;
  timestamp: string;
}

export interface AnalyticsData {
  pageViews: PageView[];
}

export interface PageStats {
  page: string;
  count: number;
}

export interface UserStats {
  user: string;
  userEntityRef: string;
  count: number;
}

export interface PageDetailStats {
  page: string;
  totalViews: number;
  uniqueUsers: number;
  userViews: UserStats[];
}

export interface UserDetailStats {
  user: string;
  userEntityRef: string;
  totalViews: number;
  uniquePages: number;
  pageViews: PageStats[];
}

export interface SummaryStats {
  totalViews: number;
  uniqueUsers: number;
  mostPopularPage: string | null;
}

export interface AnalyticsApi {
  trackPageView(page: string): Promise<void>;
  getAnalytics(startDate?: string, endDate?: string): Promise<AnalyticsData>;
  getTopPages(limit?: number, startDate?: string, endDate?: string): Promise<{ topPages: PageStats[] }>;
  getSummaryStats(startDate?: string, endDate?: string): Promise<SummaryStats>;
  getPageDetails(page: string, startDate?: string, endDate?: string): Promise<PageDetailStats>;
  getUserDetails(user: string, startDate?: string, endDate?: string): Promise<UserDetailStats>;
}

export const analyticsApiRef = createApiRef<AnalyticsApi>({
  id: 'plugin.analytics.service',
});
